module.exports = __webpack_public_path__ + "img/icon9.309bb552.png";